import gql from 'graphql-tag';

export const SaveApplicationMutation = gql`
  mutation ($applicationInput: ApplicationInput!, $applicationId: String) {
    saveApplication (application: $applicationInput, applicationId: $applicationId) 
    {
      id
    }
  }
`;

